<template>
  <div>
    <template v-if="!breadcrumb">
      <div class="col-sm-12 col-xs-12 col-md-12">
        <div class="header-team first-lette-cap">
          {{ header }}
          <base-icon
            icon="close_icon"
            class="icon-close"
            @click="$emit('closepopup', 'closeBasePopup')"
          ></base-icon>
        </div>
      </div>
      <div v-if="displaySubheader">
        <div
          class="subHeader col-md-12 first-lette-cap hide_xs"
          v-if="subheader !== 'services'"
          :class="{ 'mb-0': subheader === 'dashboard' }"
        >
          {{ subheader }}
        </div>
        <div class="subHeader col-md-12 hide_xs" v-if="subheader === 'services'">My Services</div>
        <div class="col-me-4 col-sm-4 col-xs-7">
          <multiselect
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
            class="multiselect-single-dropdown"
            :searchable="false"
            open-direction="bottom"
            :options="subPagesList"
            :custom-label="
              (value) => value.toString().charAt(0).toUpperCase() + value.toString().slice(1)
            "
            v-model="subPage"
            @input="changePage"
            placeholder="Select Page"
          >
          </multiselect>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-sm-12 col-xs-12 col-md-12">
        <div class="header-team first-lette-cap">
          <span class="hide_xs">{{ subheader }}</span>
          <span class="first-lette-cap">
            <img
              src="/static/images/icons/chevron_right.svg"
              class="hide_xs"
              width="24px"
              height="24px"
              alt="chevronright-icon"
            />
            {{ breadcrumb }}
          </span>
          <base-icon
            icon="close_icon"
            class="icon-close"
            @click="$emit('emit-close-event')"
          ></base-icon>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: [
    'subheader',
    'header',
    'breadcrumb',
    'displaySubheader',
    'roleId',
    'isDashboardCustomizable'
  ],
  data() {
    return {
      subPagesList: ['notifications', 'preferences'],
      subPage: ''
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
    }
  },
  async created() {
    if ([1,5,9].includes(this.roleId)) {
      this.subPagesList.push('team');
      this.subPagesList.push('services');
    }
    const accountTypeId = JSON.parse(localStorage.getItem('userData')).account_type_id;
    const isREP = [2,4].includes(accountTypeId);
    if (!isREP && [1,5].includes(this.roleId)) {
      this.subPagesList.push('billing');
    }
    // if (this.isDashboardCustomizable && ![4,11,10,15].includes(this.roleId)) {
    //   this.subPagesList.push('dashboard');
    // }
  },
  methods: {
    changePage() {
      this.$emit('changePage', this.subPage);
    }
  },
  watch: {
    subheader() {
      this.subPage = this.subheader;
    },
    isDashboardCustomizable() {
      if (
        this.isDashboardCustomizable &&
        ![4,10,12,13,14,15].includes(this.roleId)
      ) {
        this.subPagesList.push('dashboard');
      }
    }
  }
};
</script>
<style scoped>
.header-team {
  padding: 15px 0px 0px 0px;
  font-size: 28px;
  line-height: 33px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
}
.icon-close {
  color: #828282 !important;
  float: right;
  cursor: pointer;
}
.subHeader {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #0b3c61;
  margin-top: 10px;
  margin-bottom: 15px;
}
.mb-0 {
  margin-bottom: 0px;
}
.first-lette-cap::first-letter {
  text-transform: capitalize;
}
.multiselect-single-dropdown {
  display: none;
  margin-top: 10px;
  margin-bottom: 15px;
}
::v-deep .multiselect-single-dropdown .multiselect__content-wrapper {
  max-height: 180px !important;
}
@media screen and (max-width: 767px) {
  .hide_xs {
    display: none;
  }
}
@media screen and (max-width: 1300px) {
  .subHeader {
    display: none;
  }
  .multiselect-single-dropdown {
    display: block !important;
  }
}
@media screen and (max-width: 374px) {
  .header-team {
    font-size: 25px;
    line-height: 25px;
  }
}
</style>
